<div class="inventory-item-wrapper">
  <div class="inventory-item-in">
    <div class="inventory-item-exterior">{{ getItemExterior(exterior) }}</div>
    <div class="inventory-item-price">{{price / 100 | currency: 'USD'}}</div>
  </div>
  <div class="inventory-item-image">
    <img [src]="weapon" [alt]="name">
  </div>
  <div class="inventory-item-info">
    <div class="inventory-item-name">{{ name }}</div>
    <div class="inventory-item-rarity">{{ skin }}</div>
    <div *ngIf="status" class="status">
      <div class="bid-status">{{status}}</div>
      <app-count-down [nextStatusAt]="nextStatusAt"></app-count-down>
    </div>
  </div>
</div>
